import React, { useCallback, useEffect, useState } from "react";
import { Container } from "reactstrap";
import { useParams } from "react-router-dom";
import PageLoader from "components/common/PageLoader";
import BreadCrumb from "components/common/BreadCrumb";
import { getDocumentTitle } from "utils/helpers";
import { getPaymentExpectation } from "../services/PaymentExpectationService";
import type { PaymentExpectation } from "../types/payment-expectation.types";
import PaymentExpectationOverviewContext from "./PaymentExpectationOverviewContext";
import Section from "./Section";

const PaymentExpectationOverview = () => {
  document.title = getDocumentTitle("Collection details");
  const { id } = useParams();
  const [expectation, setExpectation] = useState<PaymentExpectation | null>(null);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    if (!id) return;
    const numericId = Number(id);
    try {
      const res = await getPaymentExpectation(numericId);
      if (res.success) setExpectation(res.data);
      else setExpectation(null);
    } catch {
      setExpectation(null);
    }
  }, [id]);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!id) { setLoading(false); return; }
      setLoading(true);
      await refetch();
      if (!cancelled) setLoading(false);
    };
    void load();
    return () => { cancelled = true; };
  }, [id, refetch]);

  if (loading) return <PageLoader message="Loading collection…" />;

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Collection details"
          pageTitle="Finance"
          items={[{ label: "Collections", path: "/finance/payment-expectations" }]}
        />
        <PaymentExpectationOverviewContext.Provider value={{ expectation, refetch }}>
          <Section />
        </PaymentExpectationOverviewContext.Provider>
      </Container>
    </div>
  );
};

export default PaymentExpectationOverview;
